export default {
      id: "inclinometer-usage",
      viewBox: "0 0 14.991 16.12",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#inclinometer",
      toString: function () {
        return this.url;
      }
    }